import React from 'react';
import { useTranslation } from 'react-i18next';
import ToggleViewList from '../../../toggleViewList/toggleViewList';
import EventCard from '../../../jo-components/cards/eventCard/eventCard';
import { classnames } from '../../../../utils/classnames';
import EmptyState from '../../../jo-components/misc/emptyState/emptyState';
import './eventsList.css';

export default function EventList({config, onSubmit}) {
    const { t } = useTranslation();
    const events = config.events_list.events || [];
    const [toggleList, setToggleList] = React.useState(true);

    const _onClick = React.useCallback((eventId) => {
        onSubmit({
            data: {
                action: 'HomeEventStep',
                event_id: eventId
            }
        })
    }, [onSubmit]);    

    return (
        <>
            <ToggleViewList toggleList={toggleList} setToggleList={setToggleList} />
            <div 
                className={classnames('event-card-wrapper', {  
                    'grid-view': !toggleList 
                })}
            >
                {events.map(event => (
                    <div key={event.id} className='event-card-list'>
                        <EventCard 
                            onClick={() => _onClick(event.id)} 
                            config={{ event_header: event }} 
                            listMode={toggleList}
                        />
                    </div>
                ))}
                {!events?.length && (
                    <EmptyState
                        icon="ticket"
                        title={t('widget.empty.events.title')}
                        subtitle={t('widget.empty.events.subtitle')}
                    />
                )}
            </div>
        </>
    )
}